// theme.js
const COLORS = {
  ANDROID_GREEN: '#A4C639',
  DARK_BLUE: '#001861',
  DARK_GREEN: '#155724',
  DARK_RED: '#721c24',
  HOVER_RED: '#c7a4a7',
  IPHONE_BLUE: '#007AFF',
  BLUE_CRAYOLA: '#2081EF',
  LIGHT_BLUE: '#ADD8E6',
  LIGHT_GREEN: '#d4edda',
  HOVER_BLUE: '#809fff',
  SIDEBAR_HOVER_BLUE: '#EBF6FC',
  HOVER_GREEN: '#b9cdbd',
  PINK: '#f8d7da',
  RED: '#FF0000',
  BORDER_RED: '#C30000',
  SAFEGUARD_BLUE: '#294062',
  BUTTON_BACKGROUND_BLUE: '#cfe1fa',
  BUTTON_BACKGROUND_GREEN: '#ddede1',
  SAFEGUARD_ORANGE: '#F36C26',
  HOVER_ORANGE: '#c45918',
  WEB_PURPLE: '#BF40BF',
  WHITE: '#ffffff',
  GREY: '#7f7f7f',
  LIGHT_GRAY: '#dededeff',
  LIGHTEST_GRAY: '#FCFCFC',
  TABLE_HEADER_GRAY: '#F1F1F1',
  TEXT_HEADER_GRAY: '#6a7282',
  MODAL_HEADER_GRAY: '#e4e4e4',
  TABLE_ROW_GRAY: '#F8F8F8',
  HOVER_GRAY: '#656565ff',
  HIGHLIGHT_YELLOW: '#FFF8E0',
  YELLOW: '#FFC107',
  CONNECT_BACKGROUND_GRAY: '#D4D4D4',
  CONNECT_TEXT_GRAY: '#424242',
  BETA_BANNER_COLOR: '#538D98',
  CHART_DONUT_PRIMARY: '#294062',
  CHART_DONUT_SECONDARY: '#548D89',
  CHART_DONUT_OTHERS: '#C5CDD8',
  CHART_DONUT_ACCENT: '#F36C26',
};

export default COLORS;
